import './media_library.upload_progress_item.less';

import AbstractItem from './media_library.abstract_item.js';

import uploadProgressItemTemplate from './media_library.upload_progress_item.tpl';

const UploadProgressItem = AbstractItem.extend({
    
    className: 'media-library-upload-progress media-library-item',
    
    
    initialize: function(){
      // takes an asset precursor as a model
      this.percent = 0;
      this.doneUploading = false;
      this.$el.attr('data-precursor-id', this.model.get('id'));
      this.on('progress', this.progress)
      this.listenTo(this.model, 'begin-post-upload-processing', this.isDoneUploading.bind(this));
    },
    
    progress: function(newPercent){
      this.percent = newPercent;
      this.render();
    },
    
    isDoneUploading: function(){
      this.doneUploading = true;
      this.render();
    },
    
    render: function() {
      var me = this
      me.$el.html(uploadProgressItemTemplate({
        percent: me.percent,
        doneUploading: me.doneUploading
      }));
      return me;
    }
    
  });
  
export default UploadProgressItem;